import nestedProperty from "nested-property";
import queryString from "query-string";
import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { startWith, Subject } from "rxjs";

export const useQueryParams$ = () => {
  const history = useHistory();
  const params$Ref = useRef(new Subject());
  useEffect(() => {
    const unsubcribe = history.listen((location) => {
      const params = queryString.parse(location.search);
      const data = {};
      Object.keys(params).forEach((key) => {
        const value = params[key];
        nestedProperty.set(data, key, value);
      });
      params$Ref.current.next(data);
    });
    return () => {
      unsubcribe();
    };

    // eslint-disable-next-line
  }, []);
  const data = getData(history);
  return params$Ref.current.pipe(startWith(data));
};

const getData = (history: any) => {
  const data = {};
  const location = history.location;
  const params = queryString.parse(location.search);
  Object.keys(params).forEach((key) => {
    const value = params[key];
    nestedProperty.set(data, key, value);
  });
  return data;
};
